import { getVmsTypesList, VmsType } from 'wisestep-api';
import { WsAutocompleteInput } from 'wisestep-base';

import WsFilterProps from '../../../components/filters/models/WsFilterProps';

import WsAccordion from './WsAccordion';

const VmsFilter = ({ name, title }: WsFilterProps) => {
  const onVmsInputKey = async (keyword: string) => {
    const result = await getVmsTypesList();
    const vmsTypes: VmsType[] = result.data;
    return vmsTypes
      .filter((vmsObj) => vmsObj.text.toLowerCase().includes(keyword.toLowerCase()))
      .map((vmsObj) => vmsObj.text);
  };

  return (
    <WsAccordion title={title ?? 'Job Source'}>
      <WsAutocompleteInput
        getOptions={onVmsInputKey}
        options={[]}
        placeholder="Eg, Michael"
        multiple={true}
        freeSolo={false}
        name={name}
        size="small"
      />
    </WsAccordion>
  );
};
export default VmsFilter;
